"use client";

import { useState } from "react";
import { useRouter } from "next/navigation";
import { Send } from "lucide-react";
import { submitContactForm } from "@/app/actions/contactSubmit";

interface ContactFormProps {
      buttonText?: string;
}

export default function ContactForm({ buttonText = "Gönder" }: ContactFormProps) {
      const router = useRouter();
      const [formData, setFormData] = useState({ name: "", number: "", email: "", mesaji: "" });
      const [isSubmitting, setIsSubmitting] = useState(false);

      const handleSubmit = async (e: React.FormEvent) => {
            e.preventDefault();
            setIsSubmitting(true);

            try {
                  const result = await submitContactForm({
                        name: formData.name.trim(),
                        number: formData.number.trim(),
                        email: formData.email.trim(),
                        mesaji: formData.mesaji.trim(),
                        sourceUrl: "https://wolisticcenter.com/iletisim",
                  });

                  if (!result.success) throw new Error(result.message);

                  router.push("/tesekkurler");
            } catch (err) {
                  console.error(err);
                  alert("Bir hata oluştu, lütfen tekrar deneyin.");
            } finally {
                  setIsSubmitting(false);
            }
      };

      return (
            <form onSubmit={handleSubmit} className="space-y-5">
                  <div className="grid md:grid-cols-2 gap-5">
                        <div className="space-y-2">
                              <label className="text-sm font-semibold text-[#404041] ml-1">Adınız Soyadınız</label>
                              <input
                                    required
                                    type="text"
                                    placeholder="Örn: Ayşe Yılmaz"
                                    value={formData.name}
                                    onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                                    className="w-full px-6 py-4 rounded-2xl bg-[#faf9f6] border border-transparent focus:bg-white focus:border-[#A68F72] outline-none transition-all"
                              />
                        </div>
                        <div className="space-y-2">
                              <label className="text-sm font-semibold text-[#404041] ml-1">Telefon</label>
                              <input
                                    required
                                    type="tel"
                                    placeholder="05XX XXX XX XX"
                                    value={formData.number}
                                    onChange={(e) => setFormData({ ...formData, number: e.target.value })}
                                    className="w-full px-6 py-4 rounded-2xl bg-[#faf9f6] border border-transparent focus:bg-white focus:border-[#A68F72] outline-none transition-all"
                              />
                        </div>
                  </div>
                  <div className="space-y-2">
                        <label className="text-sm font-semibold text-[#404041] ml-1">E-Posta</label>
                        <input
                              type="email"
                              placeholder="ornek@email.com"
                              value={formData.email}
                              onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                              className="w-full px-6 py-4 rounded-2xl bg-[#faf9f6] border border-transparent focus:bg-white focus:border-[#A68F72] outline-none transition-all"
                        />
                  </div>
                  <div className="space-y-2">
                        <label className="text-sm font-semibold text-[#404041] ml-1">Mesajınız</label>
                        <textarea
                              rows={4}
                              placeholder="Size nasıl yardımcı olabiliriz?"
                              value={formData.mesaji}
                              onChange={(e) => setFormData({ ...formData, mesaji: e.target.value })}
                              className="w-full px-6 py-4 rounded-2xl bg-[#faf9f6] border border-transparent focus:bg-white focus:border-[#A68F72] outline-none transition-all resize-none"
                        />
                  </div>
                  <button
                        type="submit"
                        disabled={isSubmitting}
                        className="w-full bg-[#A68F72] text-white font-bold py-4 rounded-2xl hover:bg-[#8f7a61] transition-all flex items-center justify-center gap-2 disabled:opacity-60 disabled:cursor-not-allowed"
                  >
                        {isSubmitting ? (
                              <div className="w-5 h-5 border-2 border-white/30 border-t-white rounded-full animate-spin" />
                        ) : (
                              <>{buttonText} <Send size={18} /></>
                        )}
                  </button>
            </form>
      );
}
